export interface SnippetInput {
  baseUrl: string;
  model: string;
  apiKeyLabel: string;
}

export interface Snippets {
  curl: string;
  python: string;
  javascript: string;
}

export function buildSnippets({ baseUrl, model, apiKeyLabel }: SnippetInput): Snippets {
  return {
    curl: `curl ${baseUrl}/chat/completions \\
  -H "Authorization: Bearer $${apiKeyLabel}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "${model}",
    "messages": [{"role": "user", "content": "Hello"}]
  }'`,
    python: `from openai import OpenAI

client = OpenAI(
    base_url="${baseUrl}",
    api_key="${apiKeyLabel}",
)

resp = client.chat.completions.create(
    model="${model}",
    messages=[{"role": "user", "content": "Hello"}],
)
print(resp.choices[0].message.content)`,
    javascript: `import OpenAI from "openai";

const client = new OpenAI({
  baseURL: "${baseUrl}",
  apiKey: "${apiKeyLabel}",
});

const resp = await client.chat.completions.create({
  model: "${model}",
  messages: [{ role: "user", content: "Hello" }],
});
console.log(resp.choices[0].message.content);`,
  };
}
